import React from "react";
import GhostBar from "./GhostBar";

const GhostFeedNewCard = () => {
  return (
    <div className="feed-new-card-container" style={{ cursor: "default" }}>
      {/* 1. Hero Image Placeholder */}
      <div className="card-hero-banner">
        <GhostBar width="100%" height="100%" style={{ borderRadius: "0px" }} />
      </div>

      {/* 2. Text Details Content Mirror */}
      <div className="new-card-info">
        {/* Title Lines (Double line layout representation) */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            width: "100%",
          }}
        >
          <GhostBar width="85%" height="18px" />
          <GhostBar width="50%" height="18px" />
        </div>

        {/* Description Body Rows */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}
        >
          <GhostBar width="100%" height="14px" />
          <GhostBar width="95%" height="14px" />
          <GhostBar width="40%" height="14px" />
        </div>

        {/* Date Row Indicator */}
        <GhostBar width="80px" height="12px" style={{ marginTop: "4px" }} />
      </div>

      {/* 3. Action Area / Buttons Mirror */}
      <div className="new-card-interactions" style={{ paddingTop: "12px" }}>
        <div className="new-card-interactions-inner">
          {/* Action Button Skeleton Shape */}
          <GhostBar
            width="140px"
            height="36px"
            style={{ borderRadius: "6px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default GhostFeedNewCard;
